import { render, staticRenderFns } from "./DividerBuilder.vue?vue&type=template&id=1f1234e8&"
import script from "./DividerBuilder.vue?vue&type=script&lang=ts&"
export * from "./DividerBuilder.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports